import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

import { Font, FontWeight } from '../../utils/fonts';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import Color from '../../utils/colors';

import AnimationContainer from '../FadeAnimation';
import ItemContent from './ItemContent';

const show = keyframes`
  from {
    max-height: 0px;
  }
  to {
    max-height: 2000px;
  }
`;
const hide = keyframes`
  from {
    max-height: 2000px;
  }
  to {
    max-height: 0px;
  }
`;

export default class DropDownList extends Component {
    constructor(props) {
        super(props);
        this.contentRef = React.createRef();

        this.state = {
            isShow: false,
            animation: null,
        };
        this.handelAnimationEnd = this.handelAnimationEnd.bind(this);
        this.handleOnClickItem = this.handleOnClickItem.bind(this);
    }

    // componentDidMount() {
    //     contentHeight = this.contentRef.current.scrollHeight;
    //     console.log(contentHeight);
    // }

    componentWillReceiveProps(nextProps) {
        const { service } = this.props;
        if (nextProps.service !== service) {
            this.setState({ isShow: false });
        }
    }

    handleOnClickItem() {
        const { isShow } = this.state;

        if (isShow) {
            this.setState({ animation: 'hide' });
        } else {
            this.setState({ isShow: true }, () => (
                this.setState({ animation: 'show' })
            ));
        }
    }

    handelAnimationEnd() {
        const { isShow, animation } = this.state;
        if (isShow && animation === 'hide') {
            this.setState({ isShow: false });
        }
    }

    render() {
        const {
            className,
            service: {
                name,
                view,
                picture,
                descriptions,
                uuid,
            },
            onLookDecisionsButtonClick,
            scrollToDecitions,
        } = this.props;

        const { isShow, animation } = this.state;

        return (
            <Container
                id={uuid}
                className={className}
            >
                <Header>
                    <ContentWrap onClick={this.handleOnClickItem}>
                        <Wrapper>
                            <IconBlock>
                                <Icon src={picture} />
                            </IconBlock>
                            <CategoryName>{view}</CategoryName>
                        </Wrapper>
                        <Sighn
                            className="sighn"
                            isShow={isShow}
                        />
                    </ContentWrap>
                </Header>
                <Content
                    onAnimationEnd={this.handelAnimationEnd}
                    isShow={isShow}
                    animation={animation}
                >
                    <ItemContentStyled
                        content={descriptions}
                        onLookDecisionsButtonClick={() => onLookDecisionsButtonClick(name)}
                        scrollToDecitions={scrollToDecitions}
                    />
                </Content>
            </Container>
        );
    }
}
const Container = styled(AnimationContainer)`
    display: flex;
    flex-direction: column;
`;

const ContentWrap = styled.div`
    width: 328px;
    margin: 0 auto;

    display: flex;
    justify-content: space-around;
    flex: 1;

    ${mediaWidth.m} {
        width: 670px;

        justify-content: space-between;
    }

    ${mediaWidth.l} {
        width: 894px;

        margin: initial;
    }

    ${mediaWidth.xl} {
        width: 1278px;
    }

`;

const Header = styled.div`
    width: 100%;

    /* :active {
        background: rgba(255, 90, 85, .16);
    }

    ${mediaWidth.m} {
        :active {
        background: rgba(255, 90, 85, .16);
        }
    } */

    ${mediaWidth.l} {
        cursor: pointer;

        :hover {
            color: ${Color.SECONDARY};
        }

        :hover .sighn:after {
            background: ${Color.SECONDARY};
        }

        :hover .sighn:before {
            background: ${Color.SECONDARY};
        }

        :active {
            color: ${Color.ACTIVE};
            background: transparent;
        }

        :active .sighn:after {
            background: ${Color.ACTIVE};
        }

        :active .sighn:before {
            background: ${Color.ACTIVE};
        }
    }
`;

const Wrapper = styled.div`
    display: flex;

    margin-right: 36px;
`;

const IconBlock = styled.div`
    width: 32px;
    height: 32px;

    margin-right: 24px;

    ${mediaWidth.m} {
        min-width: 59px;
        height: 59px;

        margin-right: 58px;
    }

    ${mediaWidth.l} {
        min-width: 77px;
        height: 77px;

        margin-right: 76px;
    }

    ${mediaWidth.xl} {
        min-width: 77px;
        height: 77px;

        margin-right: 142px;
    }
`;

const Icon = styled.img`
    display: block;

    width: 100%;
    height: 100%;
`;

const CategoryName = styled.div`
    width: 214px;

    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    font-size: 20px;
    line-height: 20px;
    text-transform: uppercase;
    white-space: pre-line;

    ${mediaWidth.m} {
        width: 100%;

        font-size: 24px;
        line-height: 24px;
    }

    ${mediaWidth.l} {
        font-size: 32px;
        line-height: 32px;
    }

    ${mediaWidth.xl} {
        font-size: 32px;
        line-height: 32px;
    }
`;

const Sighn = styled.div`
    width: 22px;
    height: 22px;

    position: relative;

    display: flex;
    align-self: center;

    &:before {
        width: 2px;
        height: 22px;
        content: ' ';

        background: #000000;

        position: absolute;
        left: 50%;

        transform: rotate(90deg);
    }

    &:after {
        width: 2px;
        height: 22px;
        content: ' ';

        background: #000000;

        position: absolute;
        left: 50%;

        transform: rotate(${({ isShow }) => (isShow ? '90deg' : '180deg')});
        transition: transform .2s ease-in;
    }

    ${mediaWidth.m} {
        width: 26px;
        height: 26px;

        &:before {
            width: 2px;
            height: 26px;
        }

        &:after {
            width: 2px;
            height: 26px;
        }
    }

    ${mediaWidth.l} {
        width: 32px;
        height: 32px;

        &:before {
            width: 2px;
            height: 32px;
        }

        &:after {
            width: 2px;
            height: 32px;
        }
    }
`;

const Content = styled.div`
    max-height: 0px;
    display: ${({ isShow }) => (isShow ? 'flex' : 'none')};
    /* display: flex; */
    justify-content: flex-end;

    margin-top: 32px;

    align-items: center;

    overflow: hidden;

    animation-name: ${({ animation }) => (animation === 'hide' ? hide : show)};
    animation-duration: 0.7s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;

    ${mediaWidth.l} {
        justify-content: center;
    }

    ${mediaWidth.xl} {
        justify-content: flex-start;
        margin-left: 220px;
    }
`;

const ItemContentStyled = styled(ItemContent)`
    width: 272px;

    ${mediaWidth.m} {
        width: 554px;
    }

    ${mediaWidth.l} {
        width: 590px;
    }

    ${mediaWidth.xl} {
        width: 733px;
    }
`;
